import _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
/*
<div>
<div>Les accès sont géré par client de façons automatiques</div>
	<AuthRender minRole={1}>
		<div>Seulement les admins</div>
	</AuthRender>
	<AuthRender minRole={3}>
		<div>Seulement les admins, directeur et managers</div>
	</AuthRender>
	<AuthRender roles={[2, 4]}>
		<div>Seulement les directeurs et CS</div>
	</AuthRender>
	<AuthRender service={1}>
		<div>Tous les utilisateurs qui ont au moins 1 accès au service 1</div>
	</AuthRender>
	<AuthRender service={1} access={["consultation"]}>
		<div>Tous les utilisateurs qui ont l'accès consultation pour le service 1</div>
	</AuthRender>
	<AuthRender service={1} access={["consultation", "export"]}>
		<div>Tous les utilisateurs qui ont l'accès consultation ET export, pour le service 1</div>
	</AuthRender>
	<AuthRender minRole={3} service={1} access={["consultation", "export"]}>
		<div>Tous les utilisateurs avec le role ADMIN, DIR, MANAGER, qui ont l'accès consultation ET export, pour le service 1</div>
	</AuthRender>
	<AuthRender  service={1} forbidden_access={["export"]}>
		<div>Tous les utilisateurs qui n'ont PAS accès aux service d'export</div>
	</AuthRender>
</div>
*/

function AuthRender(props) {
  //check role
  if (props.hasOwnProperty("minRole") && props.minRole) {
    if (props.currentRoleId > props.minRole) {
      return props.unauthorizedRender || null;
    }
  }

  //check roles
  if (props.hasOwnProperty("roles") && props.roles && props.roles.length > 0) {
    if (props.roles.indexOf(props.currentRoleId) === -1) {
      return props.unauthorizedRender || null;
    }
  }
  //check service is activated
  if (props.hasOwnProperty("service") && props.service) {
    const service = _.find(props.services, { id: props.service });

    if (!service || service.isActivated !== false) {
      return props.children;
    }

    if (!service.isActivated) {
      return props.unauthorizedRender || null;
    }
  }
  //check service
  if (props.hasOwnProperty("service") && props.service) {
    const service = _.find(props.currentServices, { id: props.service });

    if (!service) {
      return props.unauthorizedRender || null;
    }

    service.access = service.access || [];

    if (!props.hasOwnProperty("access")) {
      //at leat one === 1
      const hasAccess =
        service.access.creation ||
        service.access.modification ||
        service.access.consultation ||
        service.access.suppression ||
        service.access.download ||
        service.access.export;

      if (!hasAccess) {
        return props.unauthorizedRender || null;
      }
    } else {
      let requiredAccess = props.access;
      if (!Array.isArray(requiredAccess)) {
        requiredAccess = [requiredAccess];
      }
      for (let i = 0; i < requiredAccess.length; i++) {
        const access = requiredAccess[i];
        if (!service.access.hasOwnProperty(access) || !service.access[access]) {
          return props.unauthorizedRender || null;
        }
      }
    }

    //forbidden_access
    if (props.hasOwnProperty("forbidden_access")) {
      const forbiddentAccess = props.forbidden_access;
      for (let i = 0; i < forbiddentAccess.length; i++) {
        const access = forbiddentAccess[i];
        if (service.access.hasOwnProperty(access) && service.access[access]) {
          return props.unauthorizedRender || null;
        }
      }
    }
  }

  //check service
  if (props.hasOwnProperty("oneServiceOf") && props.oneServiceOf && props.oneServiceOf.length > 0) {
    const services = props.oneServiceOf || [];
    let hasAccess = false;

    for (let service of services) {
      const currentService = props.currentServices.find(v => v.id === service);

      if (!currentService) continue;
      currentService.access = currentService.access || [];
      //at leat one === 1
      hasAccess =
        currentService.access.creation ||
        currentService.access.modification ||
        currentService.access.consultation ||
        currentService.access.suppression ||
        currentService.access.download ||
        currentService.access.export;
      if (hasAccess) {
        break;
      }
    }
    if (!hasAccess) {
      return props.unauthorizedRender || null;
    }
  }

  if (props.hasOwnProperty("customAC") && typeof props.customAC === "function") {
    let hasAccess = props.customAC();
    if (!hasAccess) {
      return props.unauthorizedRender || null;
    }
  }
  return props.children;
}

AuthRender.propTypes = {
  roles: PropTypes.array,
  minRole: PropTypes.number,
  oneServiceOf: PropTypes.array,
  service: PropTypes.number,
  access: PropTypes.array,
  forbidden_access: PropTypes.array,
  unauthorizedRender: PropTypes.node, //render if user is not allowed to access ressource
  customAC: PropTypes.func
};

const mapStateToProps = state => {
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || 0;
  const currentUser = state.userInfos || {};
  const currentUserClients = currentUser.clients || [];
  const userState = state.user || {};
  const services = userState.servicesList || [];
  const currentUserClient = _.find(currentUserClients, { id: currentClientId }) || {};
  const currentUserClientServices = currentUserClient.services || [];

  return {
    currentServices: currentUserClientServices,
    currentRoleId: currentUser.role_id || 100,
    services
  };
};

export default connect(mapStateToProps)(AuthRender);



// WEBPACK FOOTER //
// src/containers/AuthRender.js